export default __webpack_public_path__ + "static/media/Creator.1497a4e7.svg";